import { appToday } from "../../lib/devDate";
import { currentStatisticsMonth, defaultStatisticsFilters, normalizeStatisticsMonth, statisticsMonthFilters } from "./dateRange";
import type { StatisticsFilters, StatisticsView } from "./types";

const statisticsViews = new Set<StatisticsView>(["overview", "trends", "categories", "payees", "accounts"]);

export function statisticsViewFromUrl(search: string): StatisticsView {
  const value = new URLSearchParams(search).get("view") as StatisticsView | null;
  return value && statisticsViews.has(value) ? value : "overview";
}

export function statisticsMonthFromUrl(search: string, today = appToday()) {
  return normalizeStatisticsMonth(new URLSearchParams(search).get("month"), today);
}

export function statisticsFiltersFromUrl(search: string): StatisticsFilters | null {
  const params = new URLSearchParams(search);
  if (![...params.keys()].length) return null;
  const defaults = defaultStatisticsFilters();
  const bucket = params.get("bucket");
  const type = params.get("type");
  const filters: StatisticsFilters = {
    dateFrom: params.get("from") || defaults.dateFrom,
    dateTo: params.get("to") || defaults.dateTo,
    bucket: bucket === "day" || bucket === "week" || bucket === "month" ? bucket : defaults.bucket,
    type: type === "expense" || type === "income" || type === "transfer" ? type : "",
    categoryId: params.get("category") || "",
    userId: params.get("user") || "",
    accountId: params.get("account") || "",
    tagIds: params.getAll("tag"),
    merchant: params.get("payee") || "",
    compare: params.get("compare") === "year" ? "year" : "previous",
  };
  return params.has("month") ? statisticsMonthFilters(statisticsMonthFromUrl(search), filters) : filters;
}

export function statisticsFiltersToUrlParams(filters: StatisticsFilters, view: StatisticsView = "overview", month = currentStatisticsMonth()): URLSearchParams {
  const defaults = defaultStatisticsFilters();
  const params = new URLSearchParams();
  params.set("view", view);
  if (view === "overview") {
    params.set("month", normalizeStatisticsMonth(month));
  } else {
    if (filters.dateFrom !== defaults.dateFrom) params.set("from", filters.dateFrom);
    if (filters.dateTo !== defaults.dateTo) params.set("to", filters.dateTo);
    if (filters.bucket !== defaults.bucket) params.set("bucket", filters.bucket);
  }
  if (filters.type) params.set("type", filters.type);
  if (filters.categoryId) params.set("category", filters.categoryId);
  if (filters.userId) params.set("user", filters.userId);
  if (filters.accountId) params.set("account", filters.accountId);
  filters.tagIds.forEach((tagId) => params.append("tag", tagId));
  if (filters.merchant) params.set("payee", filters.merchant);
  if (filters.compare !== "previous") params.set("compare", filters.compare);
  return params;
}
